import type { CsatSurveyVariant } from "@redotech/redo-support-settings-common/csat-survey";

/**
 * Template ids the renderer would silently fall back from, so the save can
 * refuse rather than store a selection that never takes effect.
 */
export function findUnsendableTemplateIds({
  emailTemplateId,
  abTestVariants,
  knownTemplateIds,
  missingLinkIds,
  catalogLoaded,
}: {
  emailTemplateId: string | undefined;
  abTestVariants: readonly CsatSurveyVariant[];
  knownTemplateIds: ReadonlySet<string>;
  missingLinkIds: ReadonlySet<string>;
  /** An empty catalog means "not fetched" as often as "none exist", so a
   *  missing id is only evidence of deletion once the fetch has succeeded. */
  catalogLoaded: boolean;
}): string[] {
  return [
    emailTemplateId,
    ...abTestVariants.map((variant) => variant.emailTemplateId),
  ].filter(
    (id): id is string =>
      id !== undefined &&
      ((catalogLoaded && !knownTemplateIds.has(id)) || missingLinkIds.has(id)),
  );
}
